<template>
  <div style="display: flex; justify-content: center">
    <div class="about-reppon-container">
      <div style="overflow: hidden">
        <div style="height: 100%">
          <div style="height: 100%; word-wrap: break-word; position: relative">
            <p style="text-align: center">
              <span style="color: #ebebf3"
                ><span style="font-size: 54px"
                  ><span
                    :class="props.backendFont"
                    style="font-family: Arial Black, serif"
                    >{{ props.backendFont }}</span
                  ></span
                ></span
              >
              <strong>
                <span style="font-size: 36px">
                  <span
                    style="
                      font-family: Arial Black, sans-serif;
                      position: absolute;
                      left: 35%;
                      top: 20%;
                    "
                    :class="props.className"
                    >{{ props.frontEndFont }}</span
                  ></span
                ></strong
              >
            </p>
          </div>
          <div
            style="
              width: 80px;
              height: 7px;
              background-color: #1364e9;
              margin-left: 39%;
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, nextTick } from "vue";
const props = defineProps({
  // 后方的字
  backendFont: String,
  // 前面的字
  frontEndFont: String,
  // 控制动画类名
  className: String,
});
function addCSS() {
  // 创建一个 <style> 标签
  const style = document.createElement("style");
  style.type = "text/css";

  // 定义要添加的 CSS 代码
  const css = `
        .${props.backendFont} {
          transform: scale(0);
          transition: transform 1.5s ease-out;
        }
        .${props.backendFont}.hide {
          transform: scale(1);
        }
        .${props.className} {
          transform: scale(0);
          transition: transform 0.5s ease-out;
        }
        .${props.className}.hide {
          transform: scale(1);
        }
      `;

  // 将 CSS 代码插入 <style> 标签
  if (style.styleSheet) {
    // 兼容 IE
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  // 将 <style> 标签插入 <head> 中
  document.head.appendChild(style);
}
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(`.${props.backendFont}`);
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("hide");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(`.${props.className}`);
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("hide");
    }
  }
});
nextTick(() => {
  addCSS();
});
</script>

<style scoped></style>
